import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";
import DownloadByLabel from "../components/Download/DownloadByLabel";

const OrdinaryGeneralAssemblyFilesOctober2024 = () => {
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            ملفات الجمعية العمومية العادية اكتوبر 2024
          </h1>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              كشف الحضور
            </h2>
            <DownloadByLabel
              url={"images/general-assembly/1_670cd8d0e7719.pdf"}
              name={`1_670cd8d0e7719`}
              label={"1_670cd8d0e7719.pdf"}
            />

            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              برنامج الاجتماع
            </h2>
            <DownloadByLabel
              url={"images/general-assembly/1_670e560b0170a.png"}
              name={`1_670e560b0170a`}
              label={"1_670e560b0170a.png"}
            />

            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              قواعد استثمار الفائض من اموال الجمعية والسياسات الاستثمارية
            </h2>
            <DownloadByLabel
              url={"images/general-assembly/1_670cd9cf61fc6.png"}
              name={`1_670cd9cf61fc6`}
              label={"1_670cd9cf61fc6.png"}
            />

            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              مبررات الجمعية لفتح فرع في ضاحية الدمام
            </h2>
            <DownloadByLabel
              url={"images/general-assembly/1_670cda268072d.png"}
              name={`1_670cda268072d`}
              label={"1_670cda268072d.png"}
            />

            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              خطة الاستثمار 2024-2030
            </h2>
            <DownloadByLabel
              url={"images/general-assembly/1_6710a5c11052a.pdf"}
              name={`1_6710a5c11052a`}
              label={"1_6710a5c11052a.pdf"}
            />
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default OrdinaryGeneralAssemblyFilesOctober2024;
